const PERMISSION_KEY= "crm:workflow_trigger";
const PAGE_URL = {
    WORKFLOW_TRIGGER_PAGE: "/admin/crm/workflow-trigger"
}

export {PERMISSION_KEY, PAGE_URL}

